var $37d77c66e34daccf$exports = {};
$37d77c66e34daccf$exports = {
  "dateRange": function dateRange(args) {
    return "Da ".concat(args.startDate, " a ").concat(args.endDate);
  },
  "dateSelected": function dateSelected(args) {
    return "".concat(args.date, " selezionata");
  },
  "finishRangeSelectionPrompt": "Fai clic per completare la selezione dell\u2019intervallo di date",
  "maximumDate": "Ultima data disponibile",
  "minimumDate": "Prima data disponibile",
  "next": "Successivo",
  "previous": "Precedente",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "Data selezionata: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "Intervallo selezionato: ".concat(args.dateRange);
  },
  "startRangeSelectionPrompt": "Fai clic per selezionare l\u2019intervallo di date",
  "todayDate": function todayDate(args) {
    return "Oggi, ".concat(args.date);
  },
  "todayDateSelected": function todayDateSelected(args) {
    return "Oggi, ".concat(args.date, " selezionata");
  }
};
export { $37d77c66e34daccf$exports as default };